const getInventorySourceNavigation = (t, { isAdmin = false } = {}) => [
  { to: "/dropshipping/platforms", label: t("h_inventorySource_nav_all", "Platforms") },
  { to: "/dropshipping/inventory-source", label: t("h_inventorySource_nav_inventorySource", "Inventory Source") },
  { to: "/dropshipping/inventory-source/connect", label: t("h_inventorySource_nav_connect", "Connection") },
  { to: "/dropshipping/inventory-source/suppliers", label: t("h_inventorySource_nav_suppliers", "Suppliers") },
  { to: "/dropshipping/inventory-source/products", label: t("h_inventorySource_nav_products", "Products") },
  { to: "/dropshipping/inventory-source/imported", label: t("h_inventorySource_nav_imported", "Imported") },
  { to: "/dropshipping/inventory-source/orders", label: t("h_inventorySource_nav_orders", "Orders") },
  { to: "/dropshipping/inventory-source/errors", label: t("h_inventorySource_nav_errors", "API Errors") },
  ...(isAdmin ? [
    { to: "/dropshipping/inventory-source/admin", label: t("h_inventorySource_nav_admin", "Administration") },
    { to: "/dropshipping/inventory-source/admin/connections", label: t("h_inventorySource_nav_admin_connections", "Seller connections") },
    { to: "/dropshipping/inventory-source/admin/logs", label: t("h_inventorySource_nav_admin_logs", "Secure logs") },
  ] : []),
];
module.exports = { getInventorySourceNavigation };
